module.exports = __webpack_public_path__ + "img/Favoritos.25d5dc99.png";